export var EonSparkVersion;
(function (EonSparkVersion) {
    EonSparkVersion["EON_SPARK_VERSION_1_0"] = "1.0";
})(EonSparkVersion || (EonSparkVersion = {}));
